import React from 'react';
import { Carousel } from 'react-bootstrap';

const RockBand = () => {
    return (
        <div className="roadRiderzProject">
        <h1 className="projects-Header">Rock Band4</h1>
        <div className="row site-details-rrz">
          <div className="col-md-6 p-2">
            <p>
              *  Bangladesh has legends and international standard singer so we will highlighting our singers.
            </p>
            <p>
              * Roack Band4 is a international concert organized with international standard musician like James, ayub Bacchu, Shafin.
            </p>
            <p>* Maninly Rock Band 4 work for youth</p>
            <p>
              * This site all device responsive and usung simple react, and has simple functionalities.
            </p>
            <p>* This site create with using simple react and react state management.</p>
            
           
          </div>
          <div className="col-md-6 p-2">
            <Carousel fade>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/S0s9FKJ/bd-Musician.png"
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <h3>First slide label</h3>
                  <p>
                    Nulla vitae elit libero, a pharetra augue mollis interdum.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/S0s9FKJ/bd-Musician.png"
                  alt="Second slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Second slide label</h3>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/S0s9FKJ/bd-Musician.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Third slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src="https://i.ibb.co/S0s9FKJ/bd-Musician.png"
                  alt="Third slide"
                />
  
                <Carousel.Caption>
                  {/* <h3>Fourth slide label</h3>
                  <p>
                    Praesent commodo cursus magna, vel scelerisque nisl
                    consectetur.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
       <div className="siteInfo">
       <h3 className="seeLive">See Live: </h3>
        <span >
          {" "}
          <a className="liveSite" target="_blank" href="https://band-musicians-bd.netlify.app/"><b>LiveSite</b></a>
        </span>
        <span >
          <a className="clientSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/Bangladeshi-BandMusician-React"><b>ClientSideCode</b></a>
        </span>
        {/* <span>
          <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/RoadRiderz-CustomX-NodeExpressServer-Heroku"><b>ServerSideCode</b></a>
        </span> */}
       </div>
      </div>
    );
};

export default RockBand;